import {IAddress} from "../interfaces/address";
import {CUSTOMER_PAYLOAD} from "../app.config";
import {distance} from "../utils";

export class MinimumOrderValue {
  static valid(orderValues, address: IAddress, grandTotal: Number) {
    let isValid = false;
    if (!address.location) {
      return false;
    }
    orderValues.forEach((orderValueGroup) => {
      orderValueGroup.forEach((orderValue) => {
        if (orderValue.title.toLowerCase().indexOf(address.location.toLowerCase()) > -1) {
          if (orderValue.price <= grandTotal) {
            isValid = true;
          }
        }
      });
    });
    return isValid;
  }

  static get(orderValues, address, cartTotal) {
    const constraints = this.getShippingConstraints(orderValues);
    console.log(constraints, address);
    const matchingConstraints = constraints.find(x => {
      if (!address.street || !address.streetnumber) {
        return false;
      }


      const rules = ["location", "sublocality", "street", "streetnumber", "postalcode", "radius", "excluded"].filter(key => !!x[key]);
      const matchingRules = {};
      rules.forEach((rule) => {
        switch (rule) {
          case "sublocality":
            matchingRules[rule] = address.sublocality && address.sublocality === x.sublocality;
            // Sometimes sublocality == location in gmap
            if (!matchingRules[rule]){
              matchingRules[rule] = address.location && address.location === x.sublocality;
            }
            break;

          case "location":
            matchingRules[rule] = address.location && address.location === x.location;
            break;


          case "street":
            matchingRules[rule] = address.street && (x.street === address.street || x.street.replace(" Straße", "Str.") === address.street || x.street === address.street.replace(" Straße", "Str."));
            break;

          case "streetnumber":
            matchingRules[rule] = false;
            if (address.streetnumber === x.streetnumber) {
              matchingRules[rule] = address.streetnumber === x.streetnumber;
            }

            if (x.streetnumber.indexOf("-") > -1) {
              const [fromSn, toSn] = x.streetnumber.replace(/a-zA-Z/ig, "").split("-").map((part) => parseInt(part, 10));
              if (Number.isInteger(fromSn) && Number.isInteger(toSn)) {
                matchingRules[rule] = parseInt(address.streetnumber, 10) >= fromSn && parseInt(address.streetnumber, 10) <= toSn;
              }
            }
            break;

          case "postalcode":
            matchingRules[rule] = matchingRules[rule] = x.postalcode && address.postalcode && address.postalcode == x.postalcode;
            break;

          case "radius":
            matchingRules[rule] = distance(address.lat, address.lng, CUSTOMER_PAYLOAD.latitude, CUSTOMER_PAYLOAD.longitude) <= x.radius;
            break;
        }
      });

      console.log(x, matchingRules, address);

      return rules.reduce((matching, rule) => {
        return matching && !!matchingRules[rule];
      }, true);
    });

    if (!matchingConstraints || matchingConstraints.excluded) {
      return {
        valid: false,
        invalid: false,
        unknown: true,
        postalcode: address.postalcode,
        street: address.street,
        streetnumber: address.streetNumber,
        location: address.location,
        sublocation: address.sublocation,
        minimumCartPrice: 0,
        cost: 0,
        excluded: matchingConstraints ? matchingConstraints.excluded : false,
      }
    }

    return {
      matchID: matchingConstraints.id,
      unknown: false,
      postalcode: address.postalcode,
      location: address.location,
      sublocation: address.sublocation,
      street: address.street,
      streetnumber: address.streetNumber,
      cost: matchingConstraints.cost,
      minimumCartPrice: matchingConstraints.price,
      valid: matchingConstraints.price <= cartTotal,
      invalid: matchingConstraints.price > cartTotal,
      excluded: matchingConstraints.excluded
    }
  }

  static getShippingConstraints(orderValues) {
    let constraints = [];
    orderValues.forEach((orderValueGroup) => {
      orderValueGroup.forEach((orderValue) => {
        constraints.push(orderValue);
      });
    });
    return constraints;
  }

  static resolveCity(orderValues, address: IAddress) {
    let isValid: any = false;
    if (!address.location) {
      return false;
    }
    orderValues.forEach((orderValueGroup) => {
      orderValueGroup.forEach((orderValue) => {
        if (orderValue.title.toLowerCase().indexOf(address.location.toLowerCase()) > -1) {
          isValid = address.location;
        }
      });
    });
    return isValid;
  }

  static getMinimumPrice(orderValues, address: IAddress) {
    if (!address.location) {
      return false;
    }
    let price = false;
    orderValues.forEach((orderValueGroup) => {
      orderValueGroup.forEach((orderValue) => {
        if (orderValue.title.toLowerCase().indexOf(address.location.toLowerCase()) > -1) {
          price = orderValue.price;
        }
      });
    });
    return price;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/minimum_order_value.ts